/*
  Copyright (c) 2025 Fluxonix Inc. All rights reserved.
*/

// platform_console_admin_ui/src/api/operationsCenter.js

import { api } from "../api";
import { getAuthHeaders } from "./incidents";

export async function getOperationsCenterSummary() {
  const res = await api.get("/api/secure/operations-center/summary", {
    headers: getAuthHeaders(),
  });

  return res.data;
}

export async function createPilotKpi(payload) {
  const res = await api.post("/api/secure/operations-center/kpis", payload, {
    headers: getAuthHeaders(),
  });
  return res.data;
}

export async function updatePilotKpi(kpiId, payload) {
  const res = await api.put(`/api/secure/operations-center/kpis/${kpiId}`, payload, {
    headers: getAuthHeaders(),
  });
  return res.data;
}

export async function deletePilotKpi(kpiId) {
  await api.delete(`/api/secure/operations-center/kpis/${kpiId}`, {
    headers: getAuthHeaders(),
  });
}
